  document.addEventListener('DOMContentLoaded', function() {
    const collectionsContainer = document.querySelector('.collections-container');
    const alphabetLetters = document.querySelectorAll('.alphabet-letter');
    const letterContainers = {};

    alphabetLetters.forEach(letterElem => {
      const letter = letterElem.getAttribute('data-letter');
      const groupContainer = document.createElement('div');
      groupContainer.className = 'collection-group';
      groupContainer.id = `group-${letter}`;
      groupContainer.innerHTML = `<h2 class="collection-letter">${letter}</h2>`;
      letterContainers[letter] = groupContainer;
    });

    const collectionItems = Array.from(collectionsContainer.children);

    collectionItems.forEach(item => {
      const title = item.getAttribute('data-title');
      const firstLetter = title.charAt(0).toUpperCase();

      if (letterContainers[firstLetter]) {
        letterContainers[firstLetter].appendChild(item);
      }
    });

    Object.values(letterContainers).forEach(container => {
      if (container.children.length > 1) { // Only append if there are collection items
        collectionsContainer.appendChild(container);
      }
    });
  });